import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputAdornment, InputLabel, Menu, MenuItem, Paper, Select, Stack, Tab, Tabs, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { AppointmentCard, CommonGridToolBarWithExtraFilter, CommonPatientDetails } from '../../Components/Common Components/CommonComponents'
import { DataGrid } from "@mui/x-data-grid";
import { Colors } from '../../Styles/Colors';
import { ImagePaths } from '../../Utility/ImagePaths';
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from 'react-router-dom'
import { clearCachevalue, setCachevalue } from '../../Utility/Services/CacheProviderService';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import Loader from '../../Components/Loader';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DateTime } from "luxon";
import dayjs from "dayjs";
import { ContentInTooltip, formatDate, formatDateAndTimeMeth2 } from '../../Components/CommonFunctions/CommonFunctions';
import PaymentsIcon from '@mui/icons-material/Payments';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportIcon from '@mui/icons-material/Report';


const RtScheduler = (props) => {
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [SchedulerDataList, setSchedulerDataList] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [selectedRegion, setselectedRegion] = useState(null);
    const [selectedTherapy, setselectedTherapy] = useState(null);
    const [selectedStatus, setselectedStatus] = useState("pending");
    const [FilterDate, setFilterDate] = useState(new Date());
    const [RescheduleDate, setResheduleDate] = useState(null);
    const [SearchKey, setSearchKey] = useState("");
    const [anchorEl, setanchorEl] = useState(null);
    const [TherapistList, setTherapistList] = useState([]);
    const [TherapyRegions, setTherapyRegions] = useState([]);
    const [TherapyMaster, setTherapyMaster] = useState([]);
    const [cancelTherapy, setCancelTherapy] = useState(null);
    const [selectedRow, setselectedRow] = useState(null);
    const [cancelSession, setCancelSession] = useState(null);
    const [resheduleSession, setResheduleSession] = useState(null);
    const [statusCount, setStatusCount] = useState(null);


    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
        setisloader(false)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
        setisloader(false)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    useEffect(() => {
        GetTherapyRegions();
        GetTherapyMasters();
        GetTherapistList();
    }, [])

    useEffect(() => {
        GetSchedulerList()
    }, [selectedRegion, selectedTherapy, selectedStatus, FilterDate])

    const GetSchedulerList = () => {
        setisloader(true)
        let DateFilterKey = FilterDate ? DateTime.fromJSDate(new Date(FilterDate)).toFormat('yyyy-MM-dd') : ""
        RestAPIService.getAll(Serviceurls.RT_SCHEDULER_LIST + `?status=${selectedStatus}&region_id=${selectedRegion?.id || ""}&therapy_id=${selectedTherapy?.id || ""}&date=${DateFilterKey}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    let List = response.data.data?.map((list) => ({
                        ...list,
                        temp_review_date: list?.review_date ? new Date(list?.review_date) : null
                    }))
                    setStatusCount(response.data || {})
                    setSchedulerDataList(List || []);
                    setisloader(false)
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyRegions = () => {
        RestAPIService.getAll(Serviceurls.TREATMENT_REGION_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyRegions(response.data.data || []);
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapistList = () => {
        RestAPIService.getAll(Serviceurls.USER_ACCESS_GET + "?is_therapist_role=true")
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapistList(response.data.data || []);
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyMasters = () => {
        RestAPIService.getAll(Serviceurls.RADIO_THERAPY_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyMaster(response.data.data || []);
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const postStatusData = (Data, Status) => {
        try {
            let data = {
                'status': Status,
                "radiotherapy_session_id": Data?.id
            }
            if (Status === "Re-Scheduled") {
                data["rescheduled_date"] = RescheduleDate ? DateTime.fromJSDate(new Date(RescheduleDate)).toFormat('yyyy-MM-dd') : null
            }
            if (Status === "Scheduled") {
                data["therapist_id"] = Data?.therapist?.id
                data["review_date"] = Data?.temp_review_date ? DateTime.fromJSDate(new Date(Data?.temp_review_date)).toFormat('yyyy-MM-dd') : null
            }
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.RT_SCHEDULER_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        GetSchedulerList()
                        setCancelSession(null)
                        setResheduleSession(null)
                        setResheduleDate(null)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const isValidDay = (myDate, validDays) => {
        // Convert to Date object
        const date = new Date(myDate);

        // Get day index (0 = Sunday, ..., 6 = Saturday)
        const dayIndex = date.getDay();

        // Map to weekday names
        const daysMap = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        // Expand validDays string into range
        let [startDay, , endDay] = validDays.split(" ");
        const startIndex = daysMap.indexOf(startDay);
        const endIndex = daysMap.indexOf(endDay);

        let isValid = false;

        if (startIndex !== -1 && endIndex !== -1) {
            if (startIndex <= endIndex) {
                isValid = dayIndex >= startIndex && dayIndex <= endIndex;
            } else {
                // Case like "Friday to Monday"
                isValid = dayIndex >= startIndex || dayIndex <= endIndex;
            }
        }

        return isValid
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                return (
                    <Box>
                        <CommonGridToolBarWithExtraFilter />
                    </Box>
                )
            }
            SchedulerDataList?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'patient_names', headerName: 'Patient Details', flex: 0.17,
                    renderCell: (params) => (<Box component={'div'}>
                        <CommonPatientDetails data={params?.row} />
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {params.row.tag_name ? params.row.tag_name?.length > 15 ?
                                <Tooltip placement="top" title={params.row.tag_name}><Typography sx={{ color: params.row.tag_color, fontWeight: 600, fontSize: "0.8vw" }}>{params.row.tag_name?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography sx={{ color: params.row.tag_color, fontWeight: 600, fontSize: "0.8vw" }}>{params.row.tag_name || '-'}</Typography> : '-'}
                            {params.row.doctor_name ? params.row.doctor_name?.length > 15 ?
                                <Tooltip placement="top" title={params.row.doctor_name}><Typography sx={{ fontWeight: 600, fontSize: "0.8vw", marginLeft: "0.5vw" }}>{params.row.doctor_name?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography sx={{ fontWeight: 600, fontSize: "0.8vw", marginLeft: "0.5vw" }}>{params.row.doctor_name || '-'}</Typography> : '-'}
                        </Box>

                    </Box>
                    ), valueGetter: (params) => {
                        const name = params.row?.patient_names || "";
                        const mobile = params.row?.patient_mobile_number || "";
                        const UHID = params.row?.uhid || "";
                        return `${name} ${mobile} ${UHID}`;
                    }
                },
                {
                    field: 'therapy_name', headerName: 'Therapy Details', flex: 0.10,
                    renderCell: (params) => (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: "column", }}>
                            {params.row.therapy_name ? params.row.therapy_name?.length > 17 ?
                                <Tooltip placement="top" title={params.row.therapy_name}><Typography sx={{ fontWeight: 600, fontSize: "0.8vw" }}>{params.row.therapy_name?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                <Typography sx={{ fontWeight: 600, fontSize: "0.8vw" }}>{params.row.therapy_name || '-'}</Typography> : '-'}
                            {
                                params.row.region_name ? params.row.region_name?.length > 17 ?
                                    <Tooltip placement="top" title={params.row.region_name}><Typography sx={{ fontSize: "0.8vw" }}>{params.row.region_name?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                    <Typography sx={{ fontSize: "0.8vw" }}>{params.row.region_name || '-'}</Typography> : '-'
                            }
                        </Box>
                    )
                },
                {
                    field: 'stimulator_name', headerName: 'Simulation Type', flex: 0.10,
                    renderCell: (params) => (params.row.stimulator_name ? ContentInTooltip(params.row.stimulator_name, 20) : '-')
                },
                {
                    field: 'arrival_time', headerName: 'Arrival Time', flex: 0.08,
                    renderCell: (params) => {
                        let TimeText = params.row.arrived_time ? formatDateAndTimeMeth2(params.row.arrived_time) : ""
                        const [datePart, timePart] = (TimeText ? TimeText.split("|").map((s) => s.trim()) : ["", ""]);
                        return (
                            <Box>
                                <Typography>{datePart}</Typography>
                                <Typography>{timePart}</Typography>
                            </Box>
                        )
                    }
                },
                {
                    field: 'credit_type', headerName: 'Credit Type', flex: 0.10,
                    renderCell: (params) => (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                            <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.9vw"}>{params?.row?.credit_type ? params?.row?.credit_type : "-"}</Typography>
                            <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8vw"} >{params?.row?.credit_type === "Corporate credit" ? ContentInTooltip(params?.row?.company_name, 15) : params?.row?.credit_type === "Insurance credit" ? ContentInTooltip(params?.row?.insurance_company_name, 15) : ""}</Typography>
                        </Box>)
                },
                {
                    field: 'review_date', headerName: 'Review Date', flex: 0.12,
                    renderCell: (params) => {
                        return (
                            params?.row?.review_date ? formatDate(params?.row?.review_date) :
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        disabled={params.row.session_status !== "Arrived"}
                                        value={params?.row?.temp_review_date ? params?.row?.temp_review_date : null}
                                        name={"datePicker"}
                                        inputFormat='DD-MM-YYYY'
                                        views={["year", "month", "day"]}
                                        minDate={new Date()}
                                        onChange={(newDate) => {
                                            setSchedulerDataList((prevRows) =>
                                                prevRows.map((row, index) =>
                                                    (index + 1) === params.row.sno ? {
                                                        ...row,
                                                        temp_review_date: newDate,
                                                    } : row
                                                )
                                            );
                                        }}
                                        renderInput={(dateparams) => <TextField
                                            {...dateparams}
                                            label={"Review Date"}
                                            variant="outlined"
                                            onKeyDown={(e) => e.preventDefault()}
                                            size='small'
                                            error={false}
                                            disabled={params.row.session_status !== "Arrived"}
                                        />}
                                    />
                                </LocalizationProvider>
                        )
                    }
                },
                {
                    field: 'therapist', headerName: 'Therapist', flex: 0.12,
                    renderCell: (params) => {
                        return (
                            params?.row?.therapist_name ? ContentInTooltip(params?.row?.therapist_name, 20) :
                                <Autocomplete
                                    clearIcon
                                    size='small'
                                    sx={{ width: '20vw', marginLeft: '1vw' }}
                                    disabled={params?.row?.session_status !== "Arrived"}
                                    options={TherapistList}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option.username}
                                    value={params.row.therapist || null}
                                    onChange={(e, value) => {
                                        setSchedulerDataList((prevRows) =>
                                            prevRows.map((row, index) =>
                                                (index + 1) === params.row.sno ? {
                                                    ...row,
                                                    therapist: value,
                                                } : row
                                            )
                                        );
                                    }}
                                    renderInput={(params) => <TextField disabled={params?.row?.session_status !== "Arrived"} size='small' autoComplete='off' {...params} label={"Therapist"} />}
                                />
                        )
                    }
                },
                {
                    field: 'status', headerName: 'Status', flex: 0.1,
                    renderCell: (params) => {
                        let theraphyStatus = (params?.row?.session_status === "Arrived" || params?.row?.session_status === "Scheduled") ? params?.row?.session_status : (params?.row?.session_status === "Cancelled" || params?.row?.session_status === "Re-Scheduled") ? params?.row?.session_status : params?.row?.session_status === "Pending" ? "Pending" : "-"
                        let divColor = (params?.row?.session_status === "Arrived" || params?.row?.session_status === "Scheduled") ? "#ECFFE9" : (params?.row?.session_status === "Cancelled" || params?.row?.session_status === "Re-Scheduled") ? "#FFE9E9" : params?.row?.session_status === "Pending" ? "#FFEFD8" : null;
                        let txtColor = (params?.row?.session_status === "Arrived" || params?.row?.session_status === "Scheduled") ? "#1E972A" : (params?.row?.session_status === "Cancelled" || params?.row?.session_status === "Re-Scheduled") ? "#B82121" : params?.row?.session_status === "Pending" ? "#dc8400" : null;
                        return (
                            <Stack sx={{ paddingX: "0.4vw", paddingY: "0.2vw", borderRadius: "0.2vw", backgroundColor: divColor, border: `1px solid ${txtColor}`, width: '10vw', textAlign: 'center' }}>
                                <Typography sx={{ color: txtColor, fontSize: "0.9vw" }}>{theraphyStatus ? theraphyStatus : "-"}</Typography>
                            </Stack>
                        );
                    }
                },
                {
                    field: 'action', headerName: 'Action', headerAlign: "center", flex: 0.07, align: "center",
                    renderCell: (params) => (<Box component={'div'}>
                        <Tooltip title={"Arrived"} placement="top" arrow>
                            <Button
                                disabled={(!props?.Access?.editAccess || params?.row?.session_status === "Cancelled" || params?.row?.session_status === "Arrived" || params?.row?.session_status === "Re-Scheduled" || (DateTime.fromJSDate(new Date(FilterDate)).toFormat('yyyy-MM-dd') !== DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')))}
                                onClick={() => { postStatusData(params?.row, "Arrived") }}
                                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                <img src={(!props?.Access?.editAccess || params?.row?.session_status === "Cancelled" || params?.row?.session_status === "Arrived" || params?.row?.session_status === "Re-Scheduled" || (DateTime.fromJSDate(new Date(FilterDate)).toFormat('yyyy-MM-dd') !== DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'))) ? ImagePaths.OTSurgeryConvertDisaable.default : ImagePaths.OTSurgeryConvert.default} alt="Create Bill" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={"Move to Therapist"} placement="top" arrow>
                            <Button
                                onClick={() => { postStatusData(params?.row, "Scheduled") }}
                                disabled={!(params?.row?.session_status === "Arrived" && params?.row?.therapist && props?.Access?.editAccess)}
                                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                <img src={(params?.row?.session_status === "Arrived" && params?.row?.therapist && props?.Access?.editAccess) ? ImagePaths.TickEnable.default : ImagePaths.TickDisable.default} alt="Create Bill" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={"More"} placement='top' arrow>
                            <IconButton
                                emed_tid="drg_more_icon"
                                disabled={(params?.row?.session_status === "Cancelled" || params?.row?.session_status === "Re-Scheduled")}
                                onClick={(e) => {
                                    setanchorEl(e.currentTarget)
                                    setselectedRow(params.row)
                                }}
                            >
                                <MoreVertIcon />
                            </IconButton>
                        </Tooltip>
                        {(selectedRow?.sno == params?.row?.sno && anchorEl) ?
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={() => {
                                    setanchorEl(null)
                                    setselectedRow(null)

                                }}>
                                <MenuItem className="eMed_drugMenu"
                                    disabled={!props?.Access?.editAccess}
                                    onClick={() => {
                                        setanchorEl(null)
                                        setselectedRow(null)
                                        setResheduleSession(params?.row)
                                    }}
                                >{"Reshedule"}</MenuItem>
                                <MenuItem className="eMed_drugMenu"
                                    disabled={!props?.Access?.editAccess}
                                    onClick={() => {
                                        setanchorEl(null)
                                        setselectedRow(null)
                                        setCancelSession(params?.row)
                                    }}
                                >{"Cancel Session"}</MenuItem>
                            </Menu> : null}
                    </Box>)
                },
            ];
            return (
                <Box sx={{ height: '64vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={SchedulerDataList || []}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='comfortable'
                        disableSelectionOnClick
                        loading={isloader}
                        rowHeight={60}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <div className='eMed_OP_AptHead'>
                <Box>
                    <Tabs
                        value={"Scheduler"}
                        className='eMed_bill_Tab'
                    >
                        <Tab value="Scheduler" label="Scheduler" className='eMed_tab_header eMed_bill_Tab' />
                    </Tabs>
                </Box>

                <div className='eMed_Header_OP_home_div'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={FilterDate ? FilterDate : null}
                            name={"datePicker"}
                            inputFormat='DD-MM-YYYY'
                            views={["year", "month", "day"]}
                            onChange={(newDate) => {
                                setFilterDate(newDate);
                            }}
                            renderInput={(params) => <TextField
                                {...params}
                                label={"Date"}
                                variant="outlined"
                                onKeyDown={(e) => e.preventDefault()}
                                sx={{ width: '15dvw', marginLeft: '1vw' }}
                                size='small'
                            />}
                        />
                    </LocalizationProvider>
                </div>
            </div>
            <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
                <Box display={'flex'} justifyContent={'flex-start'} flexDirection={'row'} alignItems={'center'}>
                    <Autocomplete
                        size='small'
                        options={TherapyRegions}
                        sx={{ width: '20vw' }}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option.treatment_region_name}
                        value={selectedRegion}
                        onChange={(e, value) => {
                            setselectedRegion(value)
                        }}
                        renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Region"} />}
                    />
                    <Autocomplete
                        size='small'
                        sx={{ width: '20vw', marginLeft: '1vw' }}
                        options={TherapyMaster}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option.therapy_name}
                        value={selectedTherapy}
                        onChange={(e, value) => {
                            setselectedTherapy(value)
                        }}
                        renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Therapy"} />}
                    />
                </Box>
                <Box className='eMed_OP_Apt_Cards'>
                    <AppointmentCard onClick={() => { setselectedStatus("") }} count={statusCount?.total_count || 0} label={"All"} color={"#04B7B1"} isSelectedCard={selectedStatus === "" ? true : false} />
                    <AppointmentCard onClick={() => { setselectedStatus("pending") }} count={statusCount?.total_pending_count || 0} label={"Pending"} color={"#616161"} isSelectedCard={selectedStatus === "pending" ? true : false} />
                    <AppointmentCard onClick={() => { setselectedStatus("scheduled") }} count={statusCount?.total_scheduled_count || 0} label={"Scheduled"} color={"#0461B7"} isSelectedCard={selectedStatus === "scheduled" ? true : false} />
                    <AppointmentCard onClick={() => { setselectedStatus("cancelled") }} count={statusCount?.total_cancelled_count || 0} label={"Cancelled"} color={"#B8170D"} isSelectedCard={selectedStatus === "cancelled" ? true : false} />
                </Box>
            </Box>
            <Box>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            <Dialog open={cancelSession !== null} >
                {/* <DialogTitle id="eMed_MaxDialog_Title">{"Alert !"}</DialogTitle> */}
                <DialogContent sx={{ padding: "1dvw", width: '25dvw', display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                    <Typography >{`Are You Sure ? Do you want to cancel this Session?`}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color="error" size='small' className='eMed_Filter_Btns' onClick={() => { setCancelSession(null) }}>{"Close"}</Button>
                    <Button variant='contained' color="error" size='small' className='eMed_Filter_Btns' onClick={() => { postStatusData(cancelSession, "Cancelled") }}>{"Confirm"}</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={resheduleSession !== null} >
                <DialogTitle id="eMed_MaxDialog_Title">{"Reschedule Session"}</DialogTitle>
                <DialogContent sx={{ padding: "1dvw", width: '27dvw', display: 'flex', justifyContent: "center", flexDirection: 'column' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={RescheduleDate ? RescheduleDate : null}
                            name={"datePicker"}
                            inputFormat='DD-MM-YYYY'
                            views={["year", "month", "day"]}
                            onChange={(newDate) => {
                                setResheduleDate(newDate);
                            }}
                            minDate={dayjs().add(1, "day")}
                            renderInput={(params) => <TextField
                                {...params}
                                label={"Date"}
                                variant="outlined"
                                onKeyDown={(e) => e.preventDefault()}
                                sx={{ width: '25dvw', marginTop: '0.8vw', }}
                                size='small'
                            />}
                        />
                    </LocalizationProvider>
                    <Paper
                        elevation={0}
                        sx={{
                            backgroundColor: '#F1F4FF',
                            border: '1px solid #0461B7',
                            borderRadius: '0.4vw',
                            padding: '1vw',
                            fontFamily: 'Roboto, sans-serif',
                            marginTop: "0.8vw"
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                color: '#0461B7',
                                lineHeight: '1.5',
                                margin: 0,
                                fontWeight: 400
                            }}
                        >
                            Upcoming Session dates will be automatically updated based on the Rescheduled date
                        </Typography>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => {
                        setResheduleSession(null)
                        setResheduleDate(null)
                    }}>{"Close"}</Button>
                    <Button variant='contained' size='small' className='eMed_Filter_Btns' onClick={() => {
                        if (RescheduleDate) {
                            if (isValidDay((DateTime.fromJSDate(new Date(RescheduleDate)).toFormat('yyyy-MM-dd')), resheduleSession?.treatment_frequency)) {
                                postStatusData(resheduleSession, "Re-Scheduled")
                            } else {
                                errorMessage(`Invalid Date. Rescheduled date must be with in ${resheduleSession?.treatment_frequency}`)
                            }
                        } else {
                            errorMessage("Select the Re-Schedule Date")
                        }
                    }}>{"Confirm"}</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default RtScheduler